import React from "react";
import { Row, Col, InputNumber, Switch, Divider } from "antd";

const SectionHeader = () => (
  <Row gutter={16} className="mb-2">
    <Col span={10} />
    <Col span={4} className="text-center">
      <span className="text-muted small">偵測啟動</span>
    </Col>
    <Col span={10} />
  </Row>
);

const FieldRow = ({ label, description, fieldKey, min, max, step, unit, fields, setField }) => (
  <Row gutter={16} className="mb-2 align-items-center">
    <Col span={10}>
      <label>{label}</label>
      {description && <div className="text-muted small">{description}</div>}
    </Col>
    <Col span={4} />
    <Col span={10}>
      <InputNumber
        style={{ width: "100%" }}
        min={min}
        max={max}
        step={step}
        value={fields[fieldKey]}
        onChange={(v) => setField(fieldKey, v)}
        addonAfter={unit}
      />
    </Col>
  </Row>
);

const EnableRow = ({ label, description, enabledKey, fields, setField }) => (
  <Row gutter={16} className="mb-2 align-items-center">
    <Col span={10}>
      <label className="font-weight-bold">{label}</label>
      {description && <div className="text-muted small">{description}</div>}
    </Col>
    <Col span={4} className="text-center">
      <Switch
        checked={fields[enabledKey]}
        onChange={(v) => setField(enabledKey, v)}
      />
    </Col>
    <Col span={10} />
  </Row>
);

const DurationConfig = ({ fields, setField }) => (
  <div className="pt-2">
    <SectionHeader />

    <EnableRow
      label="靜止偵測"
      description="人員在同一位置長時間未移動"
      enabledKey="stationary_enabled"
      fields={fields}
      setField={setField}
    />
    <FieldRow
      label="靜止時間閾值"
      fieldKey="stationary_minutes"
      min={1}
      max={480}
      step={5}
      unit="分鐘"
      fields={fields}
      setField={setField}
    />
    <FieldRow
      label="移動半徑閾值"
      description="小於此距離視為未移動"
      fieldKey="stationary_radius_meters"
      min={0.5}
      max={50}
      step={0.5}
      unit="公尺"
      fields={fields}
      setField={setField}
    />
    <FieldRow
      label="靜止警報冷卻時間"
      fieldKey="stationary_cooldown_seconds"
      min={60}
      max={86400}
      step={60}
      unit="秒"
      fields={fields}
      setField={setField}
    />

    <Divider />

    <EnableRow
      label="在場時長偵測"
      description="人員在場內連續停留超過設定時間"
      enabledKey="venue_duration_enabled"
      fields={fields}
      setField={setField}
    />
    <FieldRow
      label="在場時長閾值"
      fieldKey="venue_duration_minutes"
      min={1}
      max={1440}
      step={30}
      unit="分鐘"
      fields={fields}
      setField={setField}
    />
    <FieldRow
      label="離場判定間隔"
      description="超過此間隔無紀錄視為已離場，計時重置"
      fieldKey="venue_duration_gap_minutes"
      min={1}
      max={120}
      step={5}
      unit="分鐘"
      fields={fields}
      setField={setField}
    />
    <FieldRow
      label="在場警報冷卻時間"
      fieldKey="venue_duration_cooldown_seconds"
      min={60}
      max={86400}
      step={60}
      unit="秒"
      fields={fields}
      setField={setField}
    />
  </div>
);

export default DurationConfig;
